console.log('custom.js loaded');

// ==================== Key Features 默认展开 ====================
function setupKeyFeaturesExpanded() {
  console.log('Setting up Key Features to be expanded');
  
  const allDetails = document.querySelectorAll('details');
  console.log('Found details elements:', allDetails.length);
  
  allDetails.forEach(detail => {
    const summary = detail.querySelector('summary');
    if (summary) {
      const titleElement = summary.querySelector('.accordion__title');
      if (titleElement && titleElement.textContent.trim() === 'Key Features') {
        detail.setAttribute('open', '');
        console.log('Key Features expanded');
      }
    }
  });
}

// ==================== 页脚菜单折叠 - 支持动态加载 ====================
function setupFooterMenuCollapse() {
  const isMobile = window.matchMedia('(max-width: 749px)').matches;
  console.log('setupFooterMenuCollapse called, isMobile:', isMobile);
  
  if (!isMobile) {
    console.log('Desktop view, skipping footer menu collapse');
    return;
  }
  
  const toggleButtons = document.querySelectorAll('[data-footer-toggle]');
  console.log('Found toggle buttons:', toggleButtons.length);
  
  toggleButtons.forEach((button, index) => {
    // 检查是否已经绑定过事件（避免重复绑定）
    if (button.dataset.footerToggleBound) {
      console.log(`Button ${index} already bound, skipping`);
      return;
    }
    
    console.log(`Setting up button ${index}:`, button.textContent.trim());
    
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      console.log('=== CLICK EVENT TRIGGERED ===');
      console.log('Button text:', this.textContent.trim());
      
      const parent = this.closest('.footer-block');
      console.log('Parent found:', !!parent);
      
      if (!parent) {
        console.log('ERROR: Parent not found');
        return;
      }
      
      const content = parent.querySelector('.footer-block__details-content');
      console.log('Content found:', !!content);
      
      if (content) {
        const isOpen = this.classList.toggle('is-open');
        content.classList.toggle('is-open');
        
        console.log('Toggled to:', isOpen ? 'OPEN' : 'CLOSED');
        console.log('Button has is-open class:', this.classList.contains('is-open'));
        console.log('Content has is-open class:', content.classList.contains('is-open'));
      }
    });
    
    // 标记为已绑定
    button.dataset.footerToggleBound = 'true';
    console.log(`Button ${index} setup complete`);
  });
}

// 页面加载时执行
document.addEventListener('DOMContentLoaded', function() {
  console.log('DOMContentLoaded event fired');
  setupKeyFeaturesExpanded();
  setupFooterMenuCollapse();
});

// 页面完全加载后再执行一次（处理动态加载的内容）
window.addEventListener('load', function() {
  console.log('Window load event fired');
  setupKeyFeaturesExpanded();
  setupFooterMenuCollapse();
});

// 每 2 秒检查一次是否有新的菜单按钮被添加（处理动态内容）
setInterval(function() {
  const newButtons = document.querySelectorAll('[data-footer-toggle]:not([data-footer-toggle-bound="true"])');
  if (newButtons.length > 0) {
    console.log('Found new toggle buttons, setting up:', newButtons.length);
    setupFooterMenuCollapse();
  }
}, 2000);

// 监听窗口大小变化
window.addEventListener('resize', function() {
  setupFooterMenuCollapse();
});
